import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'gold' | 'outline';
  className?: string;
}
const variants = {
  gold: 'bg-gold text-ink hover:bg-gold-soft shadow-[0_18px_36px_-18px_rgba(201,162,39,0.75)] focus-visible:outline-gold',
  outline: 'border border-gold/50 text-gold-soft hover:border-gold hover:bg-gold/10 focus-visible:outline-gold'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-9 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Megapack Atletismo 360',
      value: 19,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full font-sans font-bold uppercase tracking-[0.12em] transition-[background-color,border-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-42" data-mp="35x5xfh3h2u3j">
      <span data-id="element-43" data-mp="3owtm1zx6z062">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.2} aria-hidden="true" data-id="element-44" data-mp="3ovihvyzu3qef" />
    </a>;
}